module.exports = __webpack_public_path__ + "img/Europe.39c53f28.svg";